import React, { useContext, useEffect, useState } from 'react'
import { Add, Close, Code, Group, OfflinePinOutlined, Refresh } from '@mui/icons-material'
import { useMediaQuery } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { changes, fields } from 'src/components/utils/fields'
import { BufferService, DefaultFunctionURL, LoadingContext, M_Button, M_CheckBox, M_Fieldset, M_Header, M_Select, M_SimpleTable, M_TransferList, NavigateContext } from 'src/M_Components'
import { AccountConditionOptions, BLConditionOptions, BookingConditionOptions, ConditionsFields, conditionValueField, groupFieldOptions, operandOptions, operationOptions, QuoteConditionOptions, statusOptions, SystemsTablesOptions, UsersGroupsFields } from './usersGroupsFields'
import axios from 'axios'

export const UsersGroupsCrud = () => {
  const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
  const { t } = useTranslation()
  const ctx = useContext(LoadingContext)
  const ctx2 = useContext(NavigateContext)
  const [data, setData] = useState({})
  const [users, setUsers] = useState([])
  const [isFirstTime, setIsFirstTime] = useState(true)

  const url = DefaultFunctionURL()

  const UsersGroupCreate = new BufferService('UsersGroup/create')
  const UsersGroupUpdate = new BufferService('UsersGroup/updateGroup')
  const UsersGroup = new BufferService('UsersGroup')

  const matches = useMediaQuery('(min-width:1630px)')
  const matches4 = useMediaQuery('(min-width:1250px)')
  const matches2 = useMediaQuery('(min-width:950px)')
  // const matches4 = useMediaQuery('(min-width:1150px)')
  const matches55 = useMediaQuery('(min-width:860px)')
  // const matches55 = useMediaQuery('(min-width:780px)')
  const matches6 = useMediaQuery('(min-height:740px)')
  const matches66 = useMediaQuery('(min-width:680px)')
  const matches7 = useMediaQuery('(min-width:550px)')
  const matches8 = useMediaQuery('(min-width:500px)')

  const sessionKeys = ['data', 'users']

  useEffect(() => {
    if (isFirstTime) {
      ctx.setIsLoad(true)
      getSessionStorageData(id)
      setIsFirstTime(false)
      sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
    }
  }, [])

  useEffect(() => {
    const newId = sessionStorage.getItem('selectedTab')
    if (newId !== id) {
      setId(newId)
      getSessionStorageData(newId)
    }
  })

  useEffect(() => {
    sessionKeys.forEach((key) => {
      sessionStorageMachine(id, key, key)
    })
    // eslint-disable-next-line
  }, [id, data, users])

  function sessionStorageMachine(id, key, value) {
    if (!eval(value) instanceof Array && eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return
    if (eval(value) instanceof String && eval(value) === '') return
    if (eval(value) instanceof Number && eval(value) === '') return

    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
    } else {
      // eslint-disable-next-line
      sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
    }
  }

  function getSessionStorageData(sessionID) {
    const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
    const tempU = JSON.parse(sessionStorage.getItem(`${sessionID}users`))
    if ((tempD && Object.keys(tempD).length !== 0) && (tempU && tempU !== null)) {

      setData(new Object(tempD))
      setUsers(tempU)
      ctx.setIsLoad(false)

      return
    }
    get()
  }

  function get() {
    const tempData = ctx.passValues
    ctx.setPassValues(null)
    //*Call get
    ctx.setIsLoad(false)
    if (tempData?.Operation === 'Edit') {
      UsersGroup.getId(tempData?.Row?.Id).then(info => {
        getMapping(info, tempData?.Operation)
      })
    }
    if (tempData?.Operation === 'Create') {
      changes('Operation', tempData?.Operation, setData)
    }

  }

  async function getMapping(info, Operation) {
    let newData = {
      'Id': info?.Id,
      'Operation': Operation,
      'Code': info?.Code,
      'Name': info?.Name,
      'TablesCounter': info?.TablesConditions?.length + 1,
      'Tables': await Promise.all(info?.TablesConditions?.map(async (tablesInfo, tablesIndex) => {
        let tempConditionCounter = 0
        const tempConditions = tablesInfo?.ConditionsGroup?.flatMap((groupsInfo, groupsIndex) => {
          return groupsInfo?.Conditions?.map((conditionInfo, conditionIndex) => {
            tempConditionCounter++
            return {
              'id': tempConditionCounter,
              'ConditionId': conditionInfo?.Id,
              'group': groupsIndex + 1,
              'condition': conditionInfo?.Field,
              'conditionValue': conditionInfo?.Field,
              'operation': getOperationName(conditionInfo?.Operation),
              'operationValue': getOperation(conditionInfo?.Operation),
              'value': conditionInfo?.Value
            }
          })
        })
        return {
          'id': tablesIndex + 1,
          'TablesId': tablesInfo?.Id,
          'Entities': tablesInfo?.SystemTableId,
          'EntitiesValues': tablesInfo?.SystemTableId,
          'mainOperand': getOperand(tablesInfo?.MainOperand),
          'mainOperandValues': getOperand(tablesInfo?.MainOperand),
          'conditionsCounter': tempConditions?.length + 1 || 1,
          'conditionsGroupCounter': tablesInfo?.ConditionsGroup?.length + 1,
          'conditionsList': tempConditions,
          'groupOptions': tablesInfo?.ConditionsGroup?.map((groupsInfo, groupsIndex) => {
            return {
              'GroupId': groupsInfo?.Id,
              'label': (groupsIndex + 1).toString(),
              'value': groupsIndex + 1,
              'operand': getOperand(groupsInfo?.Operand)
            }
          }),
          'options': await getTableOptions(tablesInfo?.SystemTableId)
        }
      }))
    }
    const tempUsers = info?.Users?.map(userInfo => {
      return {
        'UserName': userInfo?.UserName,
        'Email': userInfo?.Email,
        'Id': userInfo?.Id
      }
    })
    setData(newData)
    setUsers(tempUsers)
  }

  async function getTableOptions(entity) {
    const res = await axios.options(url + entity)
    return generateMetaDataOptions(res)
  }

  function getOperation(operation) {
    if (operation === 0) return 'E'
    return 'N'
  }
  function getOperationName(operation) {
    if (operation === 0) return 'Equals'
    return 'NotEquals'
  }
  function getOperand(opearand) {
    if (opearand === 0) return 'AND'
    return 'OR'
  }

  function addEntities() {
    const tempCounter = data['TablesCounter'] || 1
    const tempTables = data['Tables'] || []

    if (!data['EntitiesValues']) {
      ctx.toastMessages('error', t('NoEntitiesPicked'))
      return
    }

    axios.options(url + data['EntitiesValues']).then(res => {
      const tempOptions = generateMetaDataOptions(res)
      tempTables.push({ id: tempCounter, Entities: data['Entities'], EntitiesValues: data['EntitiesValues'], mainOperand: 'OR', mainOperandValues: 'OR', options: tempOptions })
      changes('Entities', '', setData)
      changes('EntitiesValues', '', setData)
      changes('TablesCounter', tempCounter + 1, setData)
      changes('Tables', tempTables, setData)

    }).catch(error => {
      console.log('Error: ', error)
    })

  }

  function generateMetaDataOptions(res) {
    const tempOptions = res.data.filter(opt => !opt.IsHiddenList).map(opt => {
      if (opt.IsForeignKey) {
        return { label: opt.NormalizedName, required: false, value: opt.Name, display: opt.NormalizedName, code: 'value', type: 'foreignKey', entity: opt.ForeignTableName, filterField: opt.ForeignKeyName, labelFields: [opt.ForeignKeyName], fields: [{ key: opt.ForeignKeyName, value: 'value' }, { key: 'Id', value: 'valueId' }] }
      }
      switch (opt.Type) {
        case 'boolean':
          return { label: opt.NormalizedName, required: false, value: opt.Name, display: opt.NormalizedName, code: 'value', type: 'checkBox' }
        case 'int32':
          return { label: opt.NormalizedName, required: false, value: opt.Name, display: opt.NormalizedName, code: 'value', type: 'number' }
        case 'datetime':
          return { label: opt.NormalizedName, required: false, value: opt.Name, display: opt.NormalizedName, code: 'value', type: 'date' }
        case 'string':
        default:
          return { label: opt.NormalizedName, required: false, value: opt.Name, display: opt.NormalizedName, code: 'value', type: 'text' }
      }
    })
    return tempOptions
  }

  function mainOperandChanges(row, field, obj) {
    const tempArray = data?.Tables
    const newArray = tempArray.map(old => {
      if (row.id === old.id) {
        return { ...old, [field.code]: obj && obj.label || '', [field.extraField]: obj && obj.value || '' }
      }
      return old
    })
    changes('Tables', newArray, setData)
  }

  function entityDelete(row) {
    const newArray = data?.Tables.filter(old => old.id !== row.id)
    changes('Tables', newArray, setData)
  }

  function addCondition(field) {
    let tableObj = field
    let counterGroup = field?.conditionsGroupCounter || 1
    let counter = field?.conditionsCounter || 1
    let newObj = {}
    let oldArray = field?.conditionsList || []
    let newArray = []
    let canGoIn = false
    let isIn = false

    newObj['group'] = (field['groupValue'] === 'new' || field['groupValue'] === '' || field['groupValue'] === undefined) && counterGroup || field['groupValue']
    newObj['condition'] = field['condition']
    newObj['conditionValue'] = field['conditionValue']
    newObj['operation'] = field['operation']
    newObj['operationValue'] = field['operationValue']
    newObj['value'] = field['value']
    newObj['valueId'] = field['valueId']
    newObj['id'] = counter

    if (field['groupValue'] === 'new' || field['groupValue'] === '' || field['groupValue'] === undefined) {
      let groupOptionsArray = field['groupOptions'] || []
      groupOptionsArray.push({ label: counterGroup.toString(), value: counterGroup, operand: 'OR' },)
      tableObj['groupOptions'] = groupOptionsArray
      tableObj['conditionsGroupCounter'] = counterGroup + 1
      tableObj[`group${counterGroup}`] = 'OR'

    }

    oldArray.forEach(old => {
      if (old.group === newObj.group) {
        canGoIn = true
      }
      if (canGoIn && !isIn && old.group !== newObj.group) {
        newArray.push(newObj)
        isIn = true
      }
      newArray.push(old)
    })

    if (isIn === false) {
      newArray.push(newObj)
    }

    tableObj['conditionsList'] = newArray

    tableObj['group'] = ''
    tableObj['groupValue'] = ''
    tableObj['condition'] = ''
    tableObj['conditionValue'] = ''
    tableObj['operation'] = ''
    tableObj['operationValue'] = ''
    tableObj['value'] = ''
    tableObj['valueId'] = ''
    tableObj['conditionsCounter'] = counter + 1

    const newTablesArray = data?.Tables.map(element => {
      if (element.id === tableObj.id) {
        return tableObj
      }
      return element
    })
    changes('Tables', newTablesArray, setData)
  }

  function changeConditions(row, field, obj) {
    const tempArray = data?.Tables
    const newArray = tempArray.map(old => {
      if (row.id === old.id) {
        switch (field.type) {
          case 'select':
            if (field.code === 'condition') {
              return { ...old, [field?.code]: obj && obj?.label || '', [field?.extraField]: obj && obj?.value || '', 'conditionsField': obj, value: '', valueId: '' }
            }
            return { ...old, [field?.code]: obj && obj?.label || '', [field?.extraField]: obj && obj?.value || '' }
          case 'foreignKey':
            let tempObj = {}
            field.fields.forEach(element => {
              tempObj[element.value] = obj && obj[element.key] || ''
            })
           
            return { ...old, ...tempObj }
          case 'text':
          case 'number':
          case 'date':
          case 'checkBox':
            return { ...old, [field?.code]: obj && obj || '' }
          default:
           
            return { ...old, [field?.code]: obj && obj?.label || '', [field?.extraField]: obj && obj?.value || '', }
        }
      }
      return old
    })
    changes('Tables', newArray, setData)
  }

  function groupChanges(obj, row, field, oldGroupOption) {
    const newOptions = field?.groupOptions.map(opt => {
      if (opt?.value === oldGroupOption?.value) {
        return {
          ...oldGroupOption,
          'operand': obj?.value
        }
      }
      return opt
    })
    const tempObj = { ...field, groupOptions: newOptions }
    const tempArray = data?.Tables.map(element => {
      if (element.id === field.id) {
        return tempObj
      }
      return element
    })
    changes('Tables', tempArray, setData)
  }

  function groupBody(row, field) {

    const tempValue = field?.groupOptions.find(obj => obj?.value === row?.group)

    return (
      <div style={{ display: 'flex', alignItems: 'center', padding: '10px', }}>
        <div style={{ marginRight: '20px' }}>{row['group']}</div>
        <M_Select
          autocomplete
          size={'120px'}
          required={true}
          options={operandOptions}
          value={tempValue?.operand && {
            label: tempValue?.operand,
            value: tempValue?.operand
          } || null}
          onChangeValue={(obj) => { groupChanges(obj, row, field, tempValue) }}
          color={!tempValue?.operand && 'var(--color-red)'}
          secondColor={!tempValue?.operand && 'var(--color-red)'}
        />
      </div>
    )
  }

  function body(row, column) {
    if (column === 'value' && typeof row.value == "boolean") {
      return (
        <div style={{ display: 'flex', width: '200px' }}>
          <M_CheckBox
            checked={row[column]}
          />
        </div>
      )
    }
    return (
      <div style={{ display: 'flex', width: '200px' }}>
        {
          row[column] || ''}
      </div>
    )
  }

  function deleteBody(row, field) {
    const tempConditionsList = field?.conditionsList.filter(obj => obj.id !== row.id)
    let tempField = { ...field, conditionsList: tempConditionsList }

    if (!tempConditionsList?.some(obj => obj?.group === row?.group)) {
      tempField.groupOptions = field?.groupOptions?.filter(options => options?.value !== row?.group)

      delete tempField['group' + row?.group]
    }

    const tempTables = data?.Tables.map(obj => {
      if (obj.id === tempField.id) {
        return tempField
      }
      return obj
    })
    changes('Tables', tempTables, setData)
  }

  function getConditions(conditions) {
    const newConditions = conditions?.map(obj => {
      return {
        'id': obj?.ConditionId || null,
        'field': obj?.conditionValue || obj?.condition,
        'operation': obj?.operationValue,
        'value': obj?.value
      }
    })
    return newConditions
  }

  function getConditionsGroup(groupOptions, conditionsList) {
    const newConditionsList = groupOptions?.map(obj => {
      return {
        // 'TablesConditionsGroupId': '',
        'id': obj?.GroupId || null,
        'operand': obj?.operand,
        'conditions': getConditions(conditionsList.filter(filt => filt?.group === obj?.value))
      }
    })
    return newConditionsList
  }

  function onSave() {

    const newTables = data?.Tables?.map(tempTables => {
      return {
        'id': tempTables?.TablesId,
        'mainOperand': tempTables?.mainOperand,
        // 'EntityId': '',
        'systemTableId': tempTables?.Entities,
        'conditionsGroup': getConditionsGroup(tempTables?.groupOptions, tempTables?.conditionsList)?.filter(obj=> obj?.conditions?.length !== 0),
      }
    })

    const tempSave = {
      'code': data?.Code,
      'name': data?.Name,
      'tablesConditions': newTables,
      'users': users
    }

    if (data?.Operation === 'Edit') {
      UsersGroupUpdate.update(data?.Id, tempSave).then(res => {
        if (res?.name === 'AxiosError') {
          ctx.toastMessages('error', res?.message)
          return
        }
        ctx.toastMessages('success', 'SUCCESS!, Users Group Updated!')
        ctx2.closeTab(JSON.parse(id))
      })
    }
    if (data?.Operation === 'Create') {
      UsersGroupCreate.post(tempSave).then(res => {
        if (res?.name === 'AxiosError') {
          ctx.toastMessages('error', res?.message)
          return
        }
        ctx.toastMessages('success', 'SUCCESS!, Users Group Created!')
        ctx2.closeTab(JSON.parse(id))
      })
    }
  }

  return (
    <div >
      <M_Header
        element={
          <div style={{ marginLeft: '10px' }}>
            <M_Button
              tooltip={t("Save")}
              icon={<i className="pi pi-save "></i>}
              label={t("Save")}
              onClick={() => onSave()}
            />
          </div>
        }
      />
      <div
        style={{
          display: 'flex',
          flexDirection: !matches2 && 'column',
          width: '100%',
          height: matches2 && '80vh',
          margin: '10px 0px',
          justifyContent: 'space-around'
        }}
      >
        <div
          style={{
            width: matches2 && '30%',
            height: matches2 && '100%'
          }}>
          <M_Fieldset
            height={matches6 && '100%' || '600px'}
            labelInside
            label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><Group style={{ marginRight: '10px', scale: '1.3' }} /> {t("UsersGroup")}</div>}
            elements={
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}>
                {UsersGroupsFields.map((field, index) => {
                  return <div key={index}>{fields(field, index, data, setData)}</div>
                })}
                <div style={{ margin: '10px' }}></div>
                <M_TransferList
                  height={'300px'}
                  header={t('Users')}
                  entity={'listUsers'}
                  value={users}
                  setValue={setUsers}
                  field={'UserName'}
                />
              </div>
            }
          />
        </div>
        <div
          style={{
            width: matches2 && '70%',
            height: matches2 && '100%'
          }}>
          <M_Fieldset
            labelInside
            height={matches6 && '100%' || matches2 && '600px'}
            label={<div style={{ display: 'flex', alignItems: 'center' }}><OfflinePinOutlined style={{ marginRight: '5px', fontSize: '30px', }} />{t('Conditions')}</div>}
            elements={
              <div
                style={{
                  height: matches2 && '70vh',
                  overflow: 'auto',
                }}
              >
                {data?.Tables?.length > 0 && data?.Tables?.map((field, index) => (
                  <M_Fieldset
                    key={index}
                    labelInside
                    height={'auto'}
                    label={<div style={{ display: 'flex', alignItems: 'center' }}>{field?.Entities}</div>}
                    headerElement={
                      <div style={{ marginBottom: '50px', display: 'flex', alignItems: 'center' }}>
                        {matches8 && fields(
                          { display: t('MainOperand'), required: true, code: 'mainOperand', type: 'select', options: 'operandOptions', extraField: 'mainOperandValues' },
                          'operand',
                          field,
                          setData,
                          false,
                          mainOperandChanges,
                          '120px',
                          operandOptions
                        )}
                        <div style={{ margin: '0px 20px' }}>
                          <M_Button
                            none
                            icon={<Close style={{ color: 'var(--color-red)' }} />}
                            onClick={() => entityDelete(field)}
                          />
                        </div>
                      </div>
                    }
                    elements={
                      <div>
                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '50px' }}>
                          {!matches8 && fields(
                            { display: t('MainOperand'), required: true, code: 'mainOperand', type: 'select', options: 'operandOptions', extraField: 'mainOperandValues' },
                            'operand',
                            field,
                            setData,
                            false,
                            mainOperandChanges,
                            '120px',
                            operandOptions,
                          )}
                        </div>
                        <div
                          style={{ display: 'grid', gridTemplateColumns: !matches55 && 'auto' || !matches4 && 'auto auto' || !matches && 'auto auto auto' || 'auto auto auto auto', alignItems: 'center', justifyContent: 'space-evenly', marginBottom: '20px' }}>
                          {[...ConditionsFields, { type: matches && 'whitespace' || '' }, { type: matches && 'whitespace' || '' },].map((condField, index) => {
                            const key = condField?.code || `whitespace-${index}`;
                            switch (condField?.code) {
                              case 'condition':
                                return <div key={key}>{fields(condField, index, field, setData, false, changeConditions, null, field?.options)}</div>
                              case 'value':
                                if (field['condition']) {
                                  return <div key={key}>{fields(field?.conditionsField, index, field, setData, false, changeConditions, null, statusOptions)}</div>
                                } else {
                                  return <div key={key}>{fields(condField, index, data, setData)}</div>
                                }

                              case 'operation':
                                return <div key={key}>{fields(condField, index, field, setData, null, changeConditions, null, operationOptions)}</div>

                              case 'group':
                                return <div key={key}>{fields(condField, index, field, setData, null, changeConditions, null, [...groupFieldOptions, ...(field['groupOptions'] || [])])}</div>

                              default:
                                return <div key={key}>{fields(condField, index, field, setData)}</div>
                            }
                          })}
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <M_Button
                              bold
                              normal
                              hoverEffect
                              label={t('Add')}
                              labelColor={'var(--color-white)'}
                              borderColor={'var(--color-green)'}
                              backgroundColor={'var(--color-green)'}
                              icon={<Add style={{ color: 'var(--color-white)' }} />}
                              onClick={() => addCondition(field)}
                            />
                          </div>
                        </div>
                        <div style={{ padding: '20px' }}>
                          <M_SimpleTable
                            normal={matches4}
                            rows={field['conditionsList'] && field['conditionsList'] || []}
                            columns={[
                              { 'header': t('Group'), 'field': 'group', 'body': (row) => groupBody(row, field) },
                              { 'header': t('Condition'), 'field': 'condition', 'body': (row) => body(row, 'condition') },
                              { 'header': t('Operation'), 'field': 'operation', 'body': (row) => body(row, 'operation') },
                              { 'header': t('Value'), 'field': 'value', 'body': (row) => body(row, 'value') },
                              { 'header': '', 'body': (row) => <div style={{ width: '20px', display: 'flex', justifyContent: 'center' }}><M_Button icon={<Close style={{ color: 'var(--color-red)' }} />} onClick={() => deleteBody(row, field)} /></div> },
                            ]}
                            groupField={['group']}
                          />
                        </div>
                      </div>
                    }
                  />
                ))}
                <M_Fieldset
                  labelInside
                  height={'auto'}
                  elements={
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: matches7 && 'auto auto auto' || 'auto ',
                      justifyContent: !matches7 && 'center',
                      alignItems: 'center',
                    }}>
                      <h2 style={{ display: 'flex', alignItems: 'center', justifyContent: !matches7 && 'center', }}>{t('NewTable')}</h2>
                      {fields(
                        { display: t('Entities'), translate: true, required: false, code: 'Entities', type: 'select', options: SystemsTablesOptions, extraField: 'EntitiesValues' },
                        'tablesSystems',
                        data,
                        setData,
                        true,
                        '',
                        '200px',
                        SystemsTablesOptions
                      )}
                      <div style={{
                        display: 'grid',
                        justifyContent: !matches7 && 'center',
                      }}>
                        <M_Button
                          bold
                          normal
                          hoverEffect
                          label={t('Add')}
                          labelColor={'var(--color-white)'}
                          borderColor={'var(--color-green)'}
                          backgroundColor={'var(--color-green)'}
                          icon={<Add style={{ color: 'var(--color-white)' }} />}
                          onClick={() => addEntities()}
                        />
                      </div>
                    </div>
                  }
                />
                <div
                >

                </div>
              </div>
            }
          />
        </div>
      </div>
    </div>



  )
}
